import {
  DiscoverSectionFragment,
  DiscoverItemFragment,
  PermissionsFragment,
  LinkFragment,
  SizeFragment,
  ResponsiveImageFragment,
  SingleImageFragment,
} from '@sketch/gql-types'

import {
  defaultItemMobileValues,
  defaultLinkValues,
  defaultPermissionsValues,
  defaultResponsiveImageValues,
  defaultSectionSubtitleValues,
  defaultSingleImageValues,
  defaultSizeValues,
} from '@sketch/modules-common'

import { defaultItemValues, defaultSectionValues } from './defaults'

type DiscoverItemType = NonNullable<
  | DiscoverItemFragment
  | DiscoverSectionFragment
  | PermissionsFragment
  | LinkFragment
  | SizeFragment
  | DiscoverSectionFragment['subTitle']
  | DiscoverItemFragment['mobile']
  | ResponsiveImageFragment
  | SingleImageFragment
>

const defaultValues: Record<DiscoverItemType['__typename'], any> = {
  DiscoverSection: defaultSectionValues,
  DiscoverItem: defaultItemValues,
  Permissions: defaultPermissionsValues,
  Link: defaultLinkValues,
  Size: defaultSizeValues,
  SectionSubTitle: defaultSectionSubtitleValues,
  ItemMobile: defaultItemMobileValues,
  ResponsiveImage: defaultResponsiveImageValues,
  SingleImage: defaultSingleImageValues,
}

/**
 * Adds the required default values for the given __typename.
 */
const decorateItemWithDefaultValues = (item: any) => {
  const itemKeys = Object.keys(item)

  return itemKeys.reduce((acc, curr) => {
    const itemValue = item[curr] as DiscoverItemType

    if (Array.isArray(itemValue)) {
      const newItems = visitItems(itemValue)

      return { ...acc, [curr]: newItems }

      // Search of values with __typename
    } else if (typeof itemValue === 'object') {
      const newValue = {
        ...defaultValues[itemValue.__typename],
        ...itemValue,
      }

      return { ...acc, [curr]: newValue }
    }

    return { ...acc, [curr]: itemValue }
  }, {})
}

/**
 * Iterate over all properties of a given object, and call the decorate function
 * on the ones with a __typename.
 */
export const visitItems = (items: DiscoverItemType[]): DiscoverItemType[] => {
  return items.map(item => {
    if (item && typeof item === 'object') {
      const itemWithDefaultValues = decorateItemWithDefaultValues(item)

      return { ...defaultValues[item.__typename], ...itemWithDefaultValues }
    }

    return item
  })
}
